import { createAsyncThunk } from '@reduxjs/toolkit';
import { ILocation } from './types';
import apiCall from 'utils/api';

export const fetchLocationList = createAsyncThunk(
  'location/fetchLocationList',
  async ({ page, pageSize, search }: { page: number; pageSize: number; search: string }, { rejectWithValue }) => {
    try {
      const response = await apiCall<{ status: boolean, data: ILocation[] }>('get', `/api/worker/locations/?page=${page}&page_size=${pageSize}&search=${search}`);
      return { results: response.data.data, count: response.data.data.length };
    } catch (error: any) { // eslint-disable-line @typescript-eslint/no-explicit-any
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch location list');
    }
  }
);
